var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_819_20592)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_819_20592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_819_20592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10C9.46957 10 8.96086 10.2107 8.58579 10.5858C8.22281 10.9488 8.01377 11.4369 8.00066 11.9487C8.46064 19.2366 11.5632 26.1074 16.7279 31.2721C21.8926 36.4368 28.7634 39.5394 36.0513 39.9993C36.5631 39.9862 37.0512 39.7772 37.4142 39.4142C37.7893 39.0391 38 38.5304 38 38V31.3541L30.8387 28.4895L28.715 32.029C28.1795 32.9215 27.0489 33.2541 26.1154 32.7937C21.3775 30.4571 17.5429 26.6225 15.2063 21.8846C14.7459 20.9511 15.0785 19.8205 15.971 19.285L19.5105 17.1613L16.6459 10H10ZM5.75736 7.75736C6.88258 6.63214 8.4087 6 10 6H18C18.8178 6 19.5532 6.4979 19.857 7.25722L23.857 17.2572C24.2215 18.1686 23.8707 19.2099 23.029 19.715L19.681 21.7238C21.3287 24.411 23.589 26.6713 26.2762 28.319L28.285 24.971C28.7901 24.1293 29.8314 23.7785 30.7428 24.143L40.7428 28.143C41.5021 28.4468 42 29.1822 42 30V38C42 39.5913 41.3679 41.1174 40.2426 42.2426C39.1174 43.3679 37.5913 44 36 44C35.9595 44 35.9191 43.9988 35.8787 43.9963C27.5896 43.4926 19.7715 39.9726 13.8994 34.1006C8.02738 28.2285 4.50741 20.4104 4.00368 12.1213C4.00123 12.0809 4 12.0405 4 12C4 10.4087 4.63214 8.88258 5.75736 7.75736Z",
    fill: "#1E293B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_819_20592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.466bde4e436de802592b29b043cbd1ff.svg";
export { ForwardRef as ReactComponent };